import { Reveal, Eyebrow } from "@/components/site/Motion";

const STEPS = [
  { n: "01", t: "Conhecer", d: "Uma conversa e uma visita para percebermos a personalidade e as rotinas do seu cão." },
  { n: "02", t: "Avaliar", d: "Observamos comportamento, energia e necessidades antes de qualquer serviço." },
  { n: "03", t: "Planear", d: "Definimos um plano à medida — estadia, creche, treino ou cuidados de higiene." },
  { n: "04", t: "Acompanhar", d: "Mantemo-lo informado e ajustamos sempre que for preciso." },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 sm:py-36 lg:px-12">
    <Reveal>
      <Eyebrow>O método DOG'Z</Eyebrow>
      <p className="mt-8 max-w-5xl font-serif text-4xl leading-[1.1] sm:text-6xl lg:text-[4.5rem]">
        Acreditamos que um cão <span className="italic text-[#C8D484]">equilibrado</span> é um cão feliz. Por isso tratamos cada um com{" "}
        <span className="italic text-[#C8D484]">disciplina</span>, paciência e muito carinho.
      </p>
    </Reveal>
    <div className="mt-20 grid gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.1} className="h-full">
          <div data-testid={`method-step-${s.n}`} className="group flex h-full flex-col bg-[#08090B] p-8 transition-colors duration-500 hover:bg-[#C8D484] hover:text-black">
            <span className="font-mono text-xs tracking-[0.25em] text-[#C8D484] group-hover:text-black">{s.n}</span>
            <h3 className="mt-16 font-display text-4xl font-semibold uppercase">{s.t}</h3>
            <p className="mt-4 text-sm text-white/75 group-hover:text-black/80">{s.d}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
